import { useNavigate } from "react-router-dom";

import WarningInfoGreenIcon from '@/assets/icons/warning-info-green.svg';

import { CustomersController } from "../../endpoints/customers";
import { useAppDispatch, useAppSelector } from "../../hooks/store";
import { ABSOLUTE_ROUTES } from "../../constants/routes";
import { setEligibilityFailedModalOpen } from "@/store/slices/onboarding";
import { selectEligibilityFailedModalOpen } from "@/store/slices/onboarding/selectors";
import { Button, Modal } from "@/shared/ui";

const EligibilityFailedModal = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const eligibilityFailedModalOpen = useAppSelector(selectEligibilityFailedModalOpen);

    const onConfirm = () => {
        dispatch(setEligibilityFailedModalOpen(false));
        dispatch(CustomersController.logout());
    }

    const onCancel = () => {
        dispatch(setEligibilityFailedModalOpen(false));
        navigate(ABSOLUTE_ROUTES.ONBOARDING.INSURANCE.MAIN);
    }

    return (
        <Modal dataTestId="eligibility-failed" defaultPaddings={false} open={eligibilityFailedModalOpen} onClose={onCancel} contentClassName="xl:max-w-[570px] px-[20px] py-[25px] md:px-[40px] md:py-[50px]">
            <div className="" data-testid="eligibility-failed-container">
                <div className="flex flex-col items-center justify-center text-center gap-[7px] md:gap-[15px] mb-[20px] md:mb-[25px]">
                    <img
                        width={56}
                        className="w-[2.9375rem] h-[2.9375rem] sm-max:w-9 sm-max:h-9 sm-max:mb-[0.4375rem] mb-1 sm-max:w-[48px]"
                        src={WarningInfoGreenIcon}
                        alt="warning"
                    />

                    <span className="block text-center font-agrandir text-25 md:text-35">
                        Hmm... it looks like your insurance isn’t compatible
                    </span>

                    <span className="block text-center font-agrandir text-18 md:text-22">
                        The MedBox Contracting Department will be notified about your request immediately. In the meantime, call your insurance provider and let them know you'd like to use AmeriPharma MedBox as your pharmacy provider!
                    </span>
                </div>

                <div className="flex w-full flex-col">
                    <Button
                        testId="button-eligibility-exit-account"
                        className='confirm_modal__confirm'
                        type="submit"
                        sx={{ width: '100%', marginBottom: '1rem', fontSize: '1.125rem' }}
                        onClick={onConfirm}
                        showEndIcon
                    >
                        <span>Exit Account</span>
                    </Button>
                    <Button
                        testId="button-eligibility-add-another"
                        className='confirm_modal__cancel'
                        sx={{ width: '100%', marginBottom: '1rem', fontSize: '1.125rem' }}
                        variant="outlined"
                        onClick={onCancel}
                    >
                        <span>Add Another Insurance</span>
                    </Button>
                    <Button
                        testId="button-eligibility-proceed"
                        className='confirm_modal__cancel'
                        sx={{ width: '100%', fontSize: '1.125rem' }}
                        variant="text"
                        onClick={onCancel}
                    >
                        <span>Proceed without Insurance</span>
                    </Button>
                </div>
            </div>
        </Modal>
    );
}

export default EligibilityFailedModal;